import s from "./VBaseModal.vue2.mjs";
import o from "./VBaseModal.vue3.mjs";
import t from "../../../_virtual/_plugin-vue_export-helper.mjs";
const e = {
  $style: o
}, f = /* @__PURE__ */ t(s, [["__cssModules", e]]);
export {
  f as default
};
